import React, { memo } from 'react';
import { XIcon } from 'lucide-react';
export const ProblemSection = () => {
  const problems = ['Mass-market football books are printed by the millions. They hold no long-term value.', 'Cheap merchandise (mugs, posters, scarves) fade with time and mean nothing to real collectors.', "Digital documentaries and eBooks? You can't display them, pass them down, or prove their rarity.", 'Signed memorabilia is valuable, yes—but often unauthenticated, overpriced, or impossible to verify.'];
  return <div className="bg-white py-16" data-id="element-151">
      <div className="container mx-auto px-4" data-id="element-152">
        <h2 className="text-3xl font-bold text-center mb-12" data-id="element-153">
          Why Ordinary Collectibles Fail You
        </h2>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-154">
          {problems.map((problem, index) => <div key={index} className="flex items-start p-6 bg-gray-50 rounded-lg" data-id="element-155">
              <div className="bg-red-500 p-2 rounded-full mr-4" data-id="element-156">
                <XIcon className="h-5 w-5 text-white" data-id="element-157" />
              </div>
              <p className="text-gray-700" data-id="element-158">{problem}</p>
            </div>)}
        </div>
        <div className="mt-10 p-6 bg-yellow-50 border-l-4 border-yellow-500 rounded-r-lg" data-id="element-159">
          <p className="text-gray-800 font-semibold" data-id="element-160">
            👉 The truth is, most Ronaldo "collectibles" are either
            mass-produced or risky fakes. They don't solve the true collector's
            need for authenticity, rarity, and legacy value.
          </p>
        </div>
      </div>
    </div>;
};